// 🛡️ Survivor — free DexScreener-only signal for "this launch actually LASTED",
// not a 5-min 40k pump-and-rug. Zero Helius. Rules approved with the user:
//  • ≥10 min old and still trading
//  • market cap ≥ $7k (filters dead/rugged shells)
//  • real liquidity ≥ $15k
//  • hasn't lost ~90% of value (not dumped)
//  • still alive this hour (volume didn't die vs its recent pace)
export const SURVIVOR_MIN_MCAP = 7000;
export const SURVIVOR_MIN_LIQ = 15000;
export const SURVIVOR_MIN_AGE_H = 10 / 60;

export const isSurvivor = (c) => {
  const age = c?.ageHours;
  if (age == null || age < SURVIVOR_MIN_AGE_H) return false;
  if ((c?.marketCap || 0) < SURVIVOR_MIN_MCAP) return false;
  if ((c?.liquidity || 0) < SURVIVOR_MIN_LIQ) return false;
  const pc = c?.priceChange || {};
  if ((pc.h6 ?? 0) <= -80 || (pc.h24 ?? 0) <= -85) return false; // lost ~90% → dumped/rugged
  const v1 = c?.volume?.h1 || 0;
  const v6 = c?.volume?.h6 || 0;
  if (v1 < 1500) return false;                 // still trading this hour
  if (v6 > 0 && v1 < 0.1 * v6) return false;   // hasn't gone dead vs its 6h pace
  return true;
};
